<section class="tenant-register" *appHasPermission="tenantPermissions.MODULE">
  <div class="tenant-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="tenant-register__header__map d-none">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="tenant-register__header">
    <div class="tenant-register__header__title">
      <div class="tenant-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.Management.Tenant | t }}</h1>
    </div>
    <div class="tenant-register__header__actions">
      <div class="tenant-register__header__actions__button">
        <app-button
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelRegister()"></app-button>
      </div>
      <div
        class="tenant-register__header__actions__button"
        *appHasPermission="tenantPermissions.CREATE">
        <app-button
          [id]="'register-group'"
          [label]="tk.User.Finish | t"
          [type]="'button'"
          [disabled]="tenantForm.invalid"
          (sendButtonClick)="registerTenant()"></app-button>
      </div>
    </div>
  </div>
  <div class="tenant-register__content">
    <form *ngIf="tenantForm" [formGroup]="tenantForm" appAutoFormGroup>
      <div class="form-group">
        <div class="row mb-3">
          <div class="col-12 col-sm-6 col-md-3">
            <app-select
              [label]="tk.User.Status | t"
              [options]="userStatusOptions"
              [selectedOption]="selectedStatus"
              (sendSelectedOption)="handleOptionChange($event, 'selectedStatus')"
              [placeholder]="tk.User.Select | t"></app-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <app-input
              [type]="'text'"
              [placeholder]="''"
              [controlName]="tenantRegisterProps.name"
              [label]="tk.Management.Name | t"
              [required]="true"></app-input>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <app-input
              [type]="'textarea'"
              [controlName]="tenantRegisterProps.description"
              [label]="tk.Management.Description | t"
              [required]="false"></app-input>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
